export const arrayRandom = require('./array-random').default;
